'use strict'

const GLOBAL_TESTS_VAR = '__AB_TESTS__'; // Tests are defined in stage, so change if you want to change this, change it there too

import Cookie from 'js-cookie';

/**
 * Creates new A/B test which sets a cookie, pushes data layer to GA and optionally adds CSS class to html element.
 * All the test results are stored in a variable called 'results'.
 *
 * @example
 *   test({
 *     'exampleTestName': [
 *       {
 *         value: 'true',
 *         cssClass: 'ab-test-show-example-test-class'
 *       },
 *       {
 *         value: 'false',
 *         cssClass: ''
 *       }
 *     ]
 *   });
 *
 * @param {Object} config
 *        {string} config.dataLayerVariable
 *        {number} config.expires - Cookie time to live in days
 *        {string} config.options[].{}.value - Datalayer value
 *        {string} [config.options[].{}.cssClass] - CSS class that is attached to html-element
 * @param {number} [percentageOfUsers] - Controls how many users will get the first variant (e.g. 0 = nobody, 50 = half, 100 = all).
 *                                       When used, there has to be exactly 2 variants.
 *                                       Default percentage is equal between the variants (e.q. 2 variants = 50%, 3 variants = 33% etc.).
 *
 * @return {Object}
 *         {string} name - Name of the test
 *         {Object} variant - Current variant data
 *         {boolean} isNewUser - Was it a new or a returning user
 */

const results = {};

function test(config, percentageOfUsers) {
  const name = config.dataLayerVariable;
  const variants = config.options;
  const expires = config.expires;
  const cookieName = `abTesting_${name}`;
  const currentCookie = String(Cookie.get(cookieName));

  let isNewUser = true;
  let currentVariant;

  // Check if we can find the cookie with a valid value
  if (currentCookie) {
    for (const variant of variants) {
      if (currentCookie === variant.value) {
        isNewUser = false;
        currentVariant = variant;
      }
    }
  }

  // If we couldn't find the cookie, create a new one with generated value
  if (!currentVariant) {
    if (typeof percentageOfUsers === 'number' && variants.length === 2) {
      const randomId = Math.floor(Math.random() * (10 / (percentageOfUsers / 10))) === 0;
      currentVariant = randomId ? variants[0] : variants[1];
    } else {
      const randomId = Math.floor(Math.random() * variants.length);
      currentVariant = variants[randomId];
    }

    const params = {};
    if (expires && expires > 0) {
      params.expires = expires;
    }

    Cookie.set(cookieName, String(currentVariant.value), params);
  }

  // Push data layer
  const dataLayerVar = name;
  const dataLayerObj = {};
  dataLayerObj[dataLayerVar] = currentVariant.value;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(dataLayerObj);

  // Add optional css class to html element
  if (currentVariant.cssClass) {
    document.documentElement.classList.add(currentVariant.cssClass);
  }

  const result = {
    name: name,
    variant: currentVariant,
    isNewUser: isNewUser
  };

  results[name] = result;

  return result;
}

const setAbVariant = (testName, variant, expires) => {
  const cookieName = `abTest_${testName}`;
  const params = {}
  if (expires && expires > 0) {
    params.expires = expires;
  }
  Cookie.set(cookieName, String(variant), params);
}

const runTests = function() {

  const items = window[GLOBAL_TESTS_VAR];

  if(items && items.length) {
    items.forEach(item => {
      test(item);
    });
  }
  /*
  // Sticky buy button in cart
  test({
    'PurchaseBtnAB': [
      {
        value: 'sticky',
        cssClass: ''
      },
      {
        value: 'regular',
        cssClass: ''
      }
    ]
  }, isAdmin ? 100 : 20);

  test({
    'landingPageApril2018': [
      {
        value: 'new',
        cssClass: 'new-category-landing'
      },
      {
        value: 'new',
        cssClass: 'new-category-landing'
      },
    ],
    dataLayerVar: 'LandingPageApril2018'
  }, isAdmin ? 100 : 100);*/
};

const getCurrentVariant = (testName) => {
  if (results[testName]) {
    return results[testName].variant.value;
  }
  return null;
}

export { results, setAbVariant, runTests, getCurrentVariant, test};
